export const companyBasicDemoData = {
  vat: true,
  bank: {
    company_name: null,
    local_organization_id: {
      id: null,
      country: 'DE',
    },
  },
  email: {
    email: 'contact@robertbosch.de',
    hidden: false,
  },
  phone: {
    hidden: false,
    phone_number: '+4721000800',
  },
  listed: null,
  address: {
    city: 'Stuttgart',
    coname: null,
    number: '14',
    street: ' Borsigstraße',
    country: 'DE',
    zipcode: '70469',
    side_door: null,
    coordinates: {
      lat: 59.926786,
      lng: 10.650921,
    },
    street_code: null,
    local_region: 'Oslo',
    municipality: 'Oslo',
    post_address: null,
    postdistrict: null,
  },
  purpose:
    'Tjenesteytende virksomhet innen helsetoren. Samt hva som står i forbindelse med dette, herunder å delta i andre selskap med lignende virksomhet.',
  webpage: 'https://www.bosch-home.com/',
  score_data: {
    BOHR: {
      date: '2024-11-10',
      score: 10,
      risk_assessment: 'Low',
      probability_of_distress: null,
      risk_assessment_code: 'LOW',
    },
    NEWTON: {
      date: '2024-11-10',
      score: 10,
      risk_assessment: 'Low',
      probability_of_distress: 0.00014525229926221073,
      risk_assessment_code: 'LOW',
    },
  },
  status_code: 'ACTIVE',
  company_name: 'Robert Bosch',
  company_type: {
    long: 'Aksjeselskap',
    short: 'AS',
  },
  audit_selected: null,
  financial_year: {
    end: '--12-31',
    start: '--01-01',
  },
  powers_to_bind: 'To styremedlemmer i fellesskap.',
  holding_company: false,
  last_report_date: '2023-12-31',
  company_registers: [
    {
      register: 'Enhetsregisteret',
      valid_to: null,
      valid_from: '1999-11-10',
    },
    {
      register: 'Foretaksregisteret',
      valid_to: null,
      valid_from: '2019-02-22',
    },
    {
      register: 'Merverdiavgiftsregisteret',
      valid_to: null,
      valid_from: '2019-02-22',
    },
  ],
  financial_reports: true,
  status_valid_from: '2013-06-07',
  main_industry_code: {
    code: '86906',
    isic: {
      code: '8690',
      section: 'Q',
      description: 'Other human health activities',
    },
    nace: {
      code: '8690',
      section: 'Q',
      description: 'Other human health activities',
    },
    section: 'Q',
    description: 'Medisinske laboratorietjenester',
  },
  registered_capital: {
    value: 1649381,
    currency: 'NOK',
  },
  active_not_distress: true,
  number_of_employees: {
    interval: '5000-1000',
    specific: 6789,
  },
  date_of_incorporation: '1999-11-10',
  local_organization_id: {
    country: 'NO',
    id: '981230787',
  },
  company_secondary_names: null,
  advertisement_protection: null,
  secondary_industry_codes: [
    {
      isic: {
        code: '8620',
        section: 'Q',
        description: 'Medical and dental practice activities',
      },
      nace: {
        code: '8622',
        section: 'Q',
        description: 'Specialist medical practice activities',
      },
      section: 'Q',
      priority: 1,
      group_name: 'Specialist medical practice activities',
      industry_code: '86221',
      industry_description: 'Spesialisert legetjeneste, unntatt psykiatrisk legetjeneste',
    },
  ],
  internal_id: null,
  ts: '2025-04-18T06:36:55.590464',
  status: 'Active',
  company_name_changes_count: 0,
  address_changes_count: 0,
  enterprise_credit_policy: null,
  credit_policy: null,
  score: 10,
  risk_assessment: 'Low',
  risk_assessment_code: 'LOW',
}
